import { defineStore } from 'pinia'

/**
 * 地图渲染相关的基础数据存放 例如 水井，管线，泵站，污水厂，排水单元等
 *
 *  ***** 存放大量需要渲染的数据时 用markRaw包装下再存 *****
 * 例如1万多条管道数据，如果渲染图层的时候作为响应式数据放进去，渲染速度会降低、
 */

export default defineStore({
  id: 'useStore',
  state: () => ({}),
  getters: {},
  actions: {
    /** 加载系统需要提前获取的接口，统一在这请求 */
  }
})
